import { useCallback } from 'react'
import { useDialogContext } from '@/features/shared/components/DialogContainer'

export const useGetImperativeIsDialogOpened = () => {
  const { getDialogState } = useDialogContext()

  return useCallback(() => Boolean(getDialogState.current().component), [getDialogState])
}
